import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import {
  formatUSD,
  formatDecimalNumber,
  USDT
} from '../../helpers/helperFunctions';
import { CaptionText, H3, P1, P3 } from '../../styles/FontStyles';
import { Button, Flexed } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import { Icon, IconPortfolioOrders } from '../../styles/Icons';

import { BoxPortfolio, SummaryGrid } from './Portfolio.styled';

export const WalletSummary = () => {
  const { t } = useTranslation('my_hubs');

  const { walletSummary } = useAppSelector((state) => state.portfolio);

  return (
    <>
      <Flexed mb='20' between alignEnd rowSM alignStartSM gap='16px'>
        <H3>My Products Summary</H3>
      </Flexed>
      <SummaryGrid>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioOrders />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              {t('total_personal_orders')}
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(walletSummary?.totalOrder)} <P3 mb='1'>{USDT}</P3>
            </P1>
          </div>
        </BoxPortfolio>
      </SummaryGrid>
    </>
  );
};
